import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "no",
  "use": "no-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"no\"><title>no</title><path d=\"M11.78,10l5.35-5.35a1.26,1.26,0,1,0-1.78-1.78L10,8.22,4.65,2.87A1.26,1.26,0,0,0,2.87,4.65L8.22,10,2.87,15.35a1.26,1.26,0,1,0,1.78,1.78L10,11.78l5.35,5.35a1.26,1.26,0,1,0,1.78-1.78Z\" /><rect id=\"no__矩形_3\" data-name=\" 矩形 3\" width=\"20\" height=\"20\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/no.svg
// module id = Eg9J
// module chunks = 264